import _ from "lodash";
import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { loadState } from "./localstorage";
import { APP_API_KEY, COMMON_MODAL_PAYLOAD } from "@constant";
import {
  EVENT,
  EVENT_LANGUAGES,
  EVENT_SETTINGS,
  EVENT_INTERESTS,
  STRIPE_CHARGES_LIST,
  STRIPE_CONNECTION,
  EVENT_APPUSER_COUNT,
  FORCE_REFRESH,
  COMMON_MODAL,
  COUNTRY_LIST,
} from "@mainaction";
import {
  generalRSVPSessions,
  checkoutFormData,
  formArray,
  allConditionalFields,
  sectionWiseFormArray,
  protectedPage,
  progressArray,
  lastFieldUpdated,
} from "@registrationreducer";
import {
  ticketLists,
  eventUserCategories,
  manageTicketsCount,
  assignedAttendeeTickets,
  assignedAttendeeErrors,
  promoApplied,
  promoAppliedRemoved,
  orderData,
  isUserEditopen,
  allowCCEmails,
  assignflow,
} from "@ticketsreducer";
import { proposalData } from "@proposalreducer";
import {
  reviewerToken,
  reviewerResponsesReducer,
  reviewerAllCriteriaReducer,
  reviewerAllReviewsReducer,
} from "@reviewerreducers";

const tokensReducer = (state = {}, action) => {
  state = loadState();

  if (state === undefined || state.session === undefined) {
    state = {
      session: {
        apiKey: APP_API_KEY,
        eventid: "",
        eventname: "",
        eventtimezone: "",
        seocode: "",
      },
    };
  }

  if (action.type === EVENT) {
    state.session.eventid = action.payload.eventid
      ? action.payload.eventid
      : "";
    state.session.eventname = action.payload.eventname
      ? action.payload.eventname
      : "";
    state.session.eventtimezone = action.payload.eventtimezone
      ? action.payload.eventtimezone
      : "";
    state.session.seocode = action.payload.seocode
      ? action.payload.seocode
      : "";
  }
  return state.session;
};

const eventData = (state = {}, action) => {
  if (action.type === EVENT) {
    return action.payload;
  }
  return state;
};

const eventLanguages = (state = {}, action) => {
  if (action.type === EVENT_LANGUAGES) {
    return action.payload;
  }
  return state;
};

const eventSettingsData = (state = {}, action) => {
  if (action.type === EVENT_SETTINGS) {
    return action.payload;
  }
  return state;
};

const eventInterestsData = (state = {}, action) => {
  if (action.type === EVENT_INTERESTS) {
    return action.payload;
  }
  return state;
};

const stripeChargesData = (state = {}, action) => {
  if (action.type === STRIPE_CHARGES_LIST) {
    return action.payload;
  }
  return state;
};

const stripeConnection = (state = {}, action) => {
  if (action.type === STRIPE_CONNECTION) {
    return action.payload;
  }
  return state;
};
const appuserCount = (state = {}, action) => {
  if (action.type === EVENT_APPUSER_COUNT) {
    return action.payload;
  }
  return state;
};
const commonModalReducer = (state, action) => {
  if (_.isEqual(action.type, COMMON_MODAL)) return action.payload;
  return _.cloneDeep(COMMON_MODAL_PAYLOAD);
};

const forceRefresh = (state = false, action) => {
  if (action.type === FORCE_REFRESH) {
    return action.payload;
  }
  return state;
};

const countryList = (state = [], action) => {
  if (action.type === COUNTRY_LIST) {
    return action.payload;
  }
  return state;
};

const rootReducer = combineReducers({
  form: formReducer,
  isLoggedIn: false,
  session: tokensReducer,

  eventData,
  eventLanguages,
  eventSettingsData,
  eventInterestsData,
  stripeChargesData,
  stripeConnection,
  appuserCount,
  forceRefresh,
  commonModalReducer,
  countryList,

  // Registration
  generalRSVPSessions,
  checkoutFormData,
  formArray,
  allConditionalFields,
  sectionWiseFormArray,
  protectedPage,
  progressArray,
  lastFieldUpdated,

  // Tickets
  ticketLists,
  eventUserCategories,
  manageTicketsCount,
  assignedAttendeeTickets,
  assignedAttendeeErrors,
  promoApplied,
  promoAppliedRemoved,
  orderData,
  isUserEditopen,
  allowCCEmails,
  assignflow,

  // Proposal
  proposalData,

  // Reviewer
  sessionReviewer: reviewerToken,
  reviewerResponsesReducer,
  reviewerAllCriteriaReducer,
  reviewerAllReviewsReducer,
});

export default rootReducer;
